/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CashDrawerRef,
  CashDrawerRefOptional,
  CashDrawerRefMetaI,
  CashDrawerRefTrackedI,
} from "./cash-drawer-ref";
import { CashDrawerRefTracked, CashDrawerRefMeta } from "./cash-drawer-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PrinterComputed,
  PrinterComputedOptional,
  PrinterComputedMetaI,
  PrinterComputedTrackedI,
} from "./printer-computed";
import {
  PrinterComputedTracked,
  PrinterComputedMeta,
} from "./printer-computed";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PrinterFull,
  PrinterFullOptional,
  PrinterFullMetaI,
  PrinterFullTrackedI,
} from "./printer-full";
import { PrinterFullTracked, PrinterFullMeta } from "./printer-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PrinterStatusDTO,
  PrinterStatusDTOOptional,
  PrinterStatusDTOMetaI,
  PrinterStatusDTOTrackedI,
} from "./printer-status-dto";
import {
  PrinterStatusDTOTracked,
  PrinterStatusDTOMeta,
} from "./printer-status-dto";

/**
 *
 * @export
 * @interface EditPrinterDTO
 */
export interface EditPrinterDTOOptional extends PrinterComputedOptional {
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerMAC?: string;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerUser?: string;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerName?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPrinterDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditPrinterDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof EditPrinterDTO
   */
  cashDrawer?: CashDrawerRefOptional;
  /**
   *
   * @type {boolean}
   * @memberof EditPrinterDTO
   */
  printerHasPassword?: boolean;
  /**
   *
   * @type {PrinterStatusDTO}
   * @memberof EditPrinterDTO
   */
  printerStatus?: PrinterStatusDTOOptional;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  ip?: string;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  model?: string;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerPassword?: string;
}

export interface EditPrinterDTO
  extends EditPrinterDTOOptional, PrinterComputed, PrinterFull {
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerMAC: string;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerUser?: string;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerName?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPrinterDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditPrinterDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof EditPrinterDTO
   */
  cashDrawer?: CashDrawerRef;
  /**
   *
   * @type {boolean}
   * @memberof EditPrinterDTO
   */
  printerHasPassword?: boolean;
  /**
   *
   * @type {PrinterStatusDTO}
   * @memberof EditPrinterDTO
   */
  printerStatus?: PrinterStatusDTO;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  ip?: string;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  model?: string;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerPassword?: string;
}

export interface EditPrinterDTOTrackedI extends PrinterComputedOptional {
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerMAC?: string;
  printerMACIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerUser?: string;
  printerUserIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerName?: string;
  printerNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditPrinterDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditPrinterDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof EditPrinterDTO
   */
  cashDrawer?: CashDrawerRefTrackedI;
  cashDrawerIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditPrinterDTO
   */
  printerHasPassword?: boolean;
  printerHasPasswordIsSet: boolean;
  /**
   *
   * @type {PrinterStatusDTO}
   * @memberof EditPrinterDTO
   */
  printerStatus?: PrinterStatusDTOTrackedI;
  printerStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  ip?: string;
  ipIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  model?: string;
  modelIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPrinterDTO
   */
  printerPassword?: string;
  printerPasswordIsSet: boolean;
}

transformDatesMap.set("EditPrinterDTO", function (model: EditPrinterDTO) {
  const transformDatescashDrawer = transformDatesMap.get("CashDrawerRef");
  if (transformDatescashDrawer && model.cashDrawer) {
    transformDatescashDrawer(model.cashDrawer);
  }
  const transformDatesprinterStatus = transformDatesMap.get("PrinterStatusDTO");
  if (transformDatesprinterStatus && model.printerStatus) {
    transformDatesprinterStatus(model.printerStatus);
  }
});

export type EditPrinterDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  printerMAC: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  printerUser: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  printerName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  cashDrawer: PropertyMeta<CashDrawerRefMetaI>;
  //isDate: false
  //isDatetime: false
  printerHasPassword: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  printerStatus: PropertyMeta<PrinterStatusDTOMetaI>;
  //isDate: false
  //isDatetime: false
  ip: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  model: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  printerPassword: PropertyMeta<MetaTypeBase<string>>;
}>;

export var EditPrinterDTOMeta: EditPrinterDTOMetaI = {} as EditPrinterDTOMetaI;
EditPrinterDTOMeta = typeMeta("EditPrinterDTO", {
  printerMAC: propertyMeta(
    "printerMAC",
    false,
    true,
    true,
    MetaTypesBase.string,
  ),
  printerUser: propertyMeta(
    "printerUser",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  printerName: propertyMeta(
    "printerName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  cashDrawer: propertyMeta(
    "cashDrawer",
    false,
    false,
    false,
    CashDrawerRefMeta,
  ),
  printerHasPassword: propertyMeta(
    "printerHasPassword",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  printerStatus: propertyMeta(
    "printerStatus",
    false,
    false,
    false,
    PrinterStatusDTOMeta,
  ),
  ip: propertyMeta("ip", false, false, false, MetaTypesBase.string),
  model: propertyMeta("model", false, false, false, MetaTypesBase.string),
  printerPassword: propertyMeta(
    "printerPassword",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = EditPrinterDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PrinterFullMeta]);
  metaI.printerMAC.inheritedFrom = PrinterFullMeta.printerMAC;
  metaI.printerUser.inheritedFrom = PrinterFullMeta.printerUser;
  metaI.printerName.inheritedFrom = PrinterFullMeta.printerName;
  metaI.isDeleted.inheritedFrom = PrinterFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = PrinterFullMeta.isNew;
  metaI.cashDrawer.inheritedFrom = PrinterFullMeta.cashDrawer;
  metaI.interfaces = metaI.interfaces.concat([PrinterComputedMeta]);
  metaI.printerHasPassword.inheritedFrom =
    PrinterComputedMeta.printerHasPassword;
  metaI.printerStatus.inheritedFrom = PrinterComputedMeta.printerStatus;
  metaI.ip.inheritedFrom = PrinterComputedMeta.ip;
  metaI.model.inheritedFrom = PrinterComputedMeta.model;
});

export class EditPrinterDTOTracked
  extends PrinterComputedTracked
  implements EditPrinterDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  printerMAC__I?: string = undefined;

  get printerMACIsSet() {
    return this.printerMAC !== undefined;
  }
  set printerMACIsSet(v: boolean) {}
  set printerMAC(v: undefined | string) {
    if (v !== undefined) {
      this.printerMAC__I = v;
      this.printerMACIsSet = true;
    } else {
      this.printerMAC__I = v || undefined;
      this.printerMACIsSet = true;
    }
    this.changeTracker = true;
  }
  get printerMAC() {
    return this.printerMAC__I;
  }
  printerUser__I?: string = undefined;
  printerUserIsSet: boolean = false;
  set printerUser(v: undefined | string) {
    if (v !== undefined) {
      this.printerUser__I = v;
      this.printerUserIsSet = true;
    } else {
      this.printerUser__I = v || undefined;
      this.printerUserIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerUser() {
    return this.printerUser__I;
  }
  printerName__I?: string = undefined;
  printerNameIsSet: boolean = false;
  set printerName(v: undefined | string) {
    if (v !== undefined) {
      this.printerName__I = v;
      this.printerNameIsSet = true;
    } else {
      this.printerName__I = v || undefined;
      this.printerNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerName() {
    return this.printerName__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  cashDrawer__I?: CashDrawerRefTracked = undefined;
  cashDrawerIsSet: boolean = false;
  set cashDrawer(v: undefined | CashDrawerRefTracked) {
    if (v !== undefined) {
      this.cashDrawer__I = v;
      this.cashDrawerIsSet = true;
    } else {
      this.cashDrawer__I = v || undefined;
      this.cashDrawerIsSet = false;
    }
    this.changeTracker = true;
  }
  get cashDrawer() {
    return this.cashDrawer__I;
  }
  printerHasPassword__I?: boolean = undefined;
  printerHasPasswordIsSet: boolean = false;
  set printerHasPassword(v: undefined | boolean) {
    if (v !== undefined) {
      this.printerHasPassword__I = v;
      this.printerHasPasswordIsSet = true;
    } else {
      this.printerHasPassword__I = v || undefined;
      this.printerHasPasswordIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerHasPassword() {
    return this.printerHasPassword__I;
  }
  printerStatus__I?: PrinterStatusDTOTracked = undefined;
  printerStatusIsSet: boolean = false;
  set printerStatus(v: undefined | PrinterStatusDTOTracked) {
    if (v !== undefined) {
      this.printerStatus__I = v;
      this.printerStatusIsSet = true;
    } else {
      this.printerStatus__I = v || undefined;
      this.printerStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerStatus() {
    return this.printerStatus__I;
  }
  ip__I?: string = undefined;
  ipIsSet: boolean = false;
  set ip(v: undefined | string) {
    if (v !== undefined) {
      this.ip__I = v;
      this.ipIsSet = true;
    } else {
      this.ip__I = v || undefined;
      this.ipIsSet = false;
    }
    this.changeTracker = true;
  }
  get ip() {
    return this.ip__I;
  }
  model__I?: string = undefined;
  modelIsSet: boolean = false;
  set model(v: undefined | string) {
    if (v !== undefined) {
      this.model__I = v;
      this.modelIsSet = true;
    } else {
      this.model__I = v || undefined;
      this.modelIsSet = false;
    }
    this.changeTracker = true;
  }
  get model() {
    return this.model__I;
  }
  printerPassword__I?: string = undefined;
  printerPasswordIsSet: boolean = false;
  set printerPassword(v: undefined | string) {
    if (v !== undefined) {
      this.printerPassword__I = v;
      this.printerPasswordIsSet = true;
    } else {
      this.printerPassword__I = v || undefined;
      this.printerPasswordIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerPassword() {
    return this.printerPassword__I;
  }
  constructor(config?: EditPrinterDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.printerMACIsSet == true && other?.printerMACIsSet == true)
      return this.printerMAC == other.printerMAC;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.printerMAC) {
      this.printerMACIsSet = true;
    }

    this.cashDrawer?.setIds();

    this.printerStatus?.setIds();
  }
  assignFrom(
    config: EditPrinterDTOOptional,
    options?: AssignOptions,
  ): EditPrinterDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.printerMAC &&
      this.printerMACApplyFilter(optionsRequired.filter)
    ) {
      this.printerMAC = config.printerMAC;
      if (optionsRequired.unassign) this.printerMACIsSet = false;
      else this.printerMACIsSet = true;
    }
    if (
      config.printerUser &&
      this.printerUserApplyFilter(optionsRequired.filter)
    ) {
      this.printerUser = config.printerUser;
      if (optionsRequired.unassign) this.printerUserIsSet = false;
      else this.printerUserIsSet = true;
    }
    if (
      config.printerName &&
      this.printerNameApplyFilter(optionsRequired.filter)
    ) {
      this.printerName = config.printerName;
      if (optionsRequired.unassign) this.printerNameIsSet = false;
      else this.printerNameIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.cashDrawer &&
      this.cashDrawerApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawer = new CashDrawerRefTracked(config.cashDrawer, options);
      if (optionsRequired.unassign) this.cashDrawerIsSet = false;
      else this.cashDrawerIsSet = true;
    }
    if (
      config.printerHasPassword &&
      this.printerHasPasswordApplyFilter(optionsRequired.filter)
    ) {
      this.printerHasPassword = config.printerHasPassword;
      if (optionsRequired.unassign) this.printerHasPasswordIsSet = false;
      else this.printerHasPasswordIsSet = true;
    }
    if (
      config.printerStatus &&
      this.printerStatusApplyFilter(optionsRequired.filter)
    ) {
      this.printerStatus = new PrinterStatusDTOTracked(
        config.printerStatus,
        options,
      );
      if (optionsRequired.unassign) this.printerStatusIsSet = false;
      else this.printerStatusIsSet = true;
    }
    if (config.ip && this.ipApplyFilter(optionsRequired.filter)) {
      this.ip = config.ip;
      if (optionsRequired.unassign) this.ipIsSet = false;
      else this.ipIsSet = true;
    }
    if (config.model && this.modelApplyFilter(optionsRequired.filter)) {
      this.model = config.model;
      if (optionsRequired.unassign) this.modelIsSet = false;
      else this.modelIsSet = true;
    }
    if (
      config.printerPassword &&
      this.printerPasswordApplyFilter(optionsRequired.filter)
    ) {
      this.printerPassword = config.printerPassword;
      if (optionsRequired.unassign) this.printerPasswordIsSet = false;
      else this.printerPasswordIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): EditPrinterDTOTrackedI {
    const cloned = {} as EditPrinterDTOTrackedI;
    if (
      this.printerMACIsSetDeep() &&
      this.printerMACApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerMACIsSet = true;
      cloned.printerMAC = this.printerMAC;
    } else {
      //cloned.printerMACIsSet = false
    }
    if (
      this.printerUserIsSetDeep() &&
      this.printerUserApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerUserIsSet = true;
      cloned.printerUser = this.printerUser;
    } else {
      //cloned.printerUserIsSet = false
    }
    if (
      this.printerNameIsSetDeep() &&
      this.printerNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerNameIsSet = true;
      cloned.printerName = this.printerName;
    } else {
      //cloned.printerNameIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.cashDrawerIsSetDeep() &&
      this.cashDrawerApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawerIsSet = true;
      cloned.cashDrawer = this.cashDrawer?.removeUnset(filter);
    } else {
      //cloned.cashDrawerIsSet = false
    }
    if (
      this.printerHasPasswordIsSetDeep() &&
      this.printerHasPasswordApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerHasPasswordIsSet = true;
      cloned.printerHasPassword = this.printerHasPassword;
    } else {
      //cloned.printerHasPasswordIsSet = false
    }
    if (
      this.printerStatusIsSetDeep() &&
      this.printerStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerStatusIsSet = true;
      cloned.printerStatus = this.printerStatus?.removeUnset(filter);
    } else {
      //cloned.printerStatusIsSet = false
    }
    if (
      this.ipIsSetDeep() &&
      this.ipApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ipIsSet = true;
      cloned.ip = this.ip;
    } else {
      //cloned.ipIsSet = false
    }
    if (
      this.modelIsSetDeep() &&
      this.modelApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.modelIsSet = true;
      cloned.model = this.model;
    } else {
      //cloned.modelIsSet = false
    }
    if (
      this.printerPasswordIsSetDeep() &&
      this.printerPasswordApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerPasswordIsSet = true;
      cloned.printerPassword = this.printerPassword;
    } else {
      //cloned.printerPasswordIsSet = false
    }
    if (!isDeleted(this) && !this.printerMACIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): EditPrinterDTOTrackedI {
    if (!this.printerMACApplyFilter(filter)) this.printerMACIsSet = false;

    if (!this.printerUserApplyFilter(filter)) this.printerUserIsSet = false;

    if (!this.printerNameApplyFilter(filter)) this.printerNameIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.cashDrawerApplyFilter(filter)) this.cashDrawerIsSet = false;
    this.cashDrawer?.unassignAll(filter);

    if (!this.printerHasPasswordApplyFilter(filter))
      this.printerHasPasswordIsSet = false;

    if (!this.printerStatusApplyFilter(filter)) this.printerStatusIsSet = false;
    this.printerStatus?.unassignAll(filter);

    if (!this.ipApplyFilter(filter)) this.ipIsSet = false;

    if (!this.modelApplyFilter(filter)) this.modelIsSet = false;

    if (!this.printerPasswordApplyFilter(filter))
      this.printerPasswordIsSet = false;

    return this;
  }
  printerMACApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditPrinterDTOMeta.printerMAC,
      EditPrinterDTOMeta,
      this.printerMAC,
      this,
    );
  }
  printerMACIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerMACIsSet && this.printerMACApplyFilter(filter)) return true;

    return false;
  }
  printerUserApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditPrinterDTOMeta.printerUser,
      EditPrinterDTOMeta,
      this.printerUser,
      this,
    );
  }
  printerUserIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerUserIsSet && this.printerUserApplyFilter(filter))
      return true;

    return false;
  }
  printerNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditPrinterDTOMeta.printerName,
      EditPrinterDTOMeta,
      this.printerName,
      this,
    );
  }
  printerNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerNameIsSet && this.printerNameApplyFilter(filter))
      return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditPrinterDTOMeta.isDeleted,
      EditPrinterDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditPrinterDTOMeta.isNew,
      EditPrinterDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  cashDrawerApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditPrinterDTOMeta.cashDrawer,
      EditPrinterDTOMeta,
      this.cashDrawer,
      this,
    );
  }
  cashDrawerIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cashDrawerIsSet && this.cashDrawerApplyFilter(filter)) return true;
    return this.cashDrawer?.anySet(filter) == true;

    return false;
  }
  printerHasPasswordApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditPrinterDTOMeta.printerHasPassword,
      EditPrinterDTOMeta,
      this.printerHasPassword,
      this,
    );
  }
  printerHasPasswordIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.printerHasPasswordIsSet &&
      this.printerHasPasswordApplyFilter(filter)
    )
      return true;

    return false;
  }
  printerStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditPrinterDTOMeta.printerStatus,
      EditPrinterDTOMeta,
      this.printerStatus,
      this,
    );
  }
  printerStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerStatusIsSet && this.printerStatusApplyFilter(filter))
      return true;
    return this.printerStatus?.anySet(filter) == true;

    return false;
  }
  ipApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(EditPrinterDTOMeta.ip, EditPrinterDTOMeta, this.ip, this);
  }
  ipIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ipIsSet && this.ipApplyFilter(filter)) return true;

    return false;
  }
  modelApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditPrinterDTOMeta.model,
      EditPrinterDTOMeta,
      this.model,
      this,
    );
  }
  modelIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.modelIsSet && this.modelApplyFilter(filter)) return true;

    return false;
  }
  printerPasswordApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EditPrinterDTOMeta.printerPassword,
      EditPrinterDTOMeta,
      this.printerPassword,
      this,
    );
  }
  printerPasswordIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerPasswordIsSet && this.printerPasswordApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.printerMACIsSetDeep(filter)) return true;
    if (this.printerUserIsSetDeep(filter)) return true;
    if (this.printerNameIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.cashDrawerIsSetDeep(filter)) return true;
    if (this.printerHasPasswordIsSetDeep(filter)) return true;
    if (this.printerStatusIsSetDeep(filter)) return true;
    if (this.ipIsSetDeep(filter)) return true;
    if (this.modelIsSetDeep(filter)) return true;
    if (this.printerPasswordIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
